module.exports = __webpack_public_path__ + "img/adset-icon-dark.45888cac.svg";